import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { cancelSubmission } from '@common/services/submissionService';

export const useCancelSubmission = () => {
  const { mutate, isLoading } = useWaitingMutation((submissionId: number) => cancelSubmission(submissionId, {}));

  return { cancelSubmission: mutate, isCancellingSubmission: isLoading };
};
